import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { featuredMovies } from '@/mocks/movies';
import type { Movie } from '@/mocks/movies';

export default function FeaturedMovies() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = useCallback(() => {
    setCurrentIndex((prev) => (prev + 1) % featuredMovies.length);
  }, []);

  const prevSlide = useCallback(() => {
    setCurrentIndex((prev) => (prev - 1 + featuredMovies.length) % featuredMovies.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, [nextSlide]);

  const movie: Movie = featuredMovies[currentIndex];

  return (
    <section className="py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">每周精选高分佳作，不容错过</p>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={prevSlide}
              className="w-10 h-10 rounded-full bg-background-100 hover:bg-background-200 flex items-center justify-center transition-colors cursor-pointer"
              aria-label="上一部"
            >
              <i className="ri-arrow-left-s-line text-foreground-700"></i>
            </button>
            <button
              onClick={nextSlide}
              className="w-10 h-10 rounded-full bg-background-100 hover:bg-background-200 flex items-center justify-center transition-colors cursor-pointer"
              aria-label="下一部"
            >
              <i className="ri-arrow-right-s-line text-foreground-700"></i>
            </button>
          </div>
        </div>

        <Link
          to={`/article/${movie.id}`}
          className="group block relative overflow-hidden rounded-2xl cursor-pointer"
          data-product-shop="true"
        >
          <div className="relative h-[320px] md:h-[420px]">
            <div
              className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105"
              style={{ backgroundImage: `url(${movie.backdrop})` }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-background-950/30 to-transparent"></div>

            <div className="absolute bottom-0 left-0 right-0 p-6 md:p-10">
              <div className="flex items-center gap-3 mb-3">
                <span className="px-3 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                  {movie.subCategory}
                </span>
                <span className="text-xs text-background-200 flex items-center gap-1">
                  <i className="ri-star-fill text-accent-400 text-sm"></i>
                  {movie.rating}
                </span>
                <span className="text-xs text-background-300">{movie.year}</span>
                <span className="text-xs text-background-300">{movie.duration}</span>
              </div>
              <h3 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-2">
                {movie.title}
              </h3>
              <p className="text-sm text-background-200/80 max-w-xl line-clamp-2">
                {movie.description}
              </p>
            </div>
          </div>
        </Link>

        <div className="flex items-center justify-center gap-2 mt-4">
          {featuredMovies.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                index === currentIndex
                  ? 'bg-primary-500 w-6'
                  : 'bg-background-300 hover:bg-background-400'
              }`}
              aria-label={`第${index + 1}部`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}